const doc = [({"zh_tw":({"buttonBookingActivity":({"cancelBookingPlan":"取消此預訂", "cancelBookingRoom":"取消此體驗的預訂"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;